import React, { useState } from 'react';
import { useForm } from "antd/es/form/Form";
import { useTranslation } from "react-i18next";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { EntBasicHB } from "../../../../models/handBooks/basicHB";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import _ from "lodash";
import { PageHeader } from "../../../../components/page-header";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { FilterByNameHB } from "../../../../components/filterByNameHB/FilterByNameHB";
import { AddHBModal } from "../../../../components/addHBModal/AddHBModal";
import { useLazyGetLegalFormListQuery } from "../../../../redux/api/handBooksApi/organic/legalFormApi";
import { useLegalForm } from "./useLegalForm";

enum FormField {
  name
}

export const LegalForm = () => {
  const [form] = useForm();
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntBasicHB>(new EntBasicHB());
  const [showModal, setShowModal] = useState<boolean>(false);
  const { onAddLegalForm, onDeleteLegalForm, onEditLegalForm } = useLegalForm(modal, () => {
	searchHandleClick();
  })
  const [getArchiveFolders] = useLazyGetLegalFormListQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntBasicHB, EntInitialFilter>({
	initialFilter: new EntInitialFilter(),
	query: getArchiveFolders
  });
  const [height, setHeight] = useState<number>(0);
  const openAddModal = (item: EntBasicHB) => {
	setSelectedItem(item);
	setShowModal(true);
  }
  const setEntityFromFields = (): EntInitialFilter => {
	let filt: EntInitialFilter = _.clone(filter);
	filt.name = form.getFieldValue(FormField.name) ?? null;
	filt.page = 1;
	return filt;
  }
  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	]);
  }
  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.nameKy }</td>
			<td>{ item?.nameRu }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteLegalForm(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('Юридические формы') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } }
						   type="secondary"> { t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntBasicHB)
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={
		  <FilterByNameHB
			onSearch={ searchHandleClick }
			onReset={ () => {
			  clearFields();
			  searchHandleClick()
			} }
			formField={ FormField }
			form={ form }
		  />
		}
		setHeight={ setHeight }
		table={ table }

	  />
	  <AddHBModal
		item={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== 0 ? onEditLegalForm : onAddLegalForm }
	  />
	  { contextHolder }
	</>
  )
}